import React from 'react'
import { Link } from 'react-router-dom'
import banner from '../assets/banner.png'
import logo from '../assets/logo_transparent.png'

const Header = () => {
    return (
        <Link className='link' to={'/'}>
            <div className='headerContainer'>
            <img src={logo} className="bannerLogo" alt="logo" />
            <img src={banner} className='header' />
            </div>


        </Link>
    )
}

export default Header